<template>
  <div class="pages-search">
    <div v-if="detailShow" class="resource-detail-block">
      <resource-detail
        :show="detailShow"
        @onReturn="detailShow = false"
        :detailData="detailData"
        detailType="2"
        isSearch
        :origin="origin"
      ></resource-detail>
    </div>
  </div>
</template>

<script>
import { getTerm, getTags, findResource, group, resDetail } from '@/api/api.js'
import { getFileType } from '@/utils/utils.js'
import ResourceDetail from '../../components/resourceDetail.vue'

export default {
  components: { ResourceDetail },
  name: 'Search',
  data: () => ({
    inputValue: '',
    termList: [],
    termValue: '',
    tagList: [],
    tagValue: '',
    authorityList: ['是', '否'],
    authorityValue: '',
    fileTypeList: ['图片', '视频', '音频', 'word', 'pdf', 'ppt'],
    fileTypeValue: '',
    selectTime: '',
    timeValue: '',

    showResult: false,
    data: [],
    pageNum: 1,
    total: 0,

    detailShow: false,
    detailData: {},
    origin: '',
  }),

  async mounted() {
    console.log(3145631)
    // let termRes = await getTerm()
    let termRes = await group()
    // console.log('termRes', termRes)
    this.termList = termRes.data.data

    let tagsRes = await getTags()
    // console.log('tagsRes', tagsRes)
    this.tagList = tagsRes.data.data

    resDetail(this.$route.query.id).then((res) => {
      if (res.data.code == 0) {
        console.log('res', res)
        let data = { ...res.data.data }
        data.last_verify = res.data.data.verify[res.data.data.verify.length - 1]
        this.detailData = data
        this.detailShow = true
      }
    })
  },
  methods: {
    getFileType,
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    toBack() {
      this.$router.back()
    },
    toInputValue() {
      console.log(document.getElementById('input').value)
      this.inputValue = document.getElementById('input').value
    },
    toSearch() {
      // console.log('inputValue', this.inputValue)
      // return
      let data = { page: this.pageNum, status: 0, title: this.inputValue }
      if (this.termValue) {
        // data.term = this.termValue
        data.group1 = this.termValue
      }
      if (this.tagValue) {
        data.tag = this.tagValue
      }
      if (this.authorityValue) {
        data.is_gftj = this.authorityValue == '是' ? 1 : 0
      }
      if (this.fileTypeValue) {
        data.file_type = this.fileTypeValue
      }
      if (this.timeValue) {
        let date = new Date(this.timeValue)
        data.date = `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${
          date.getMonth() + 1
        }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`
      }
      console.log('data', data)
      // return
      findResource(data).then((res) => {
        this.data = res.data.data.list
        this.total = res.data.data.total
        this.showResult = true
      })
    },
    pageChange(e) {
      this.pageNum = e
      this.toSearch()
    },
    toPreview(item) {
      console.log('toPreview', item)
      this.detailShow = true
      setTimeout(() => {
        this.origin = item.is_gfpt == 1 ? 2 : 1
        this.detailData = item
      }, 10)
    },
  },
}
</script>

<style lang="less" scoped>
.pages-search {
  // min-width: 1600px;

  .top-line {
    display: flex;
    height: 84px;
    padding-left: 40px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .search-input {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100%;
    width: calc(100vw - 640px);
    max-width: 1280px;
    height: 190px;
    // min-width: 1561px;
    margin: 0 auto;
    .input-value {
      // width: 1280px;
      width: calc(100vw - 810px);
      max-width: 1280px;
      height: 90px;
      padding: 0 60px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // color: #999999;
      color: #4d4d4d;
      line-height: 90px;
      background: #ffffff;
      border-radius: 45px 0 0 45px !important;
      border: none;
      box-sizing: border-box;
      // outline: 1px solid #10b3ff;
    }
    input::-webkit-input-placeholder {
      /* WebKit browsers*/
      color: #999999;
    }
    input:-moz-input-placeholder {
      /* Mozilla Firefox 4 to 18*/
      color: #999999;
    }
    input::-moz-input-placeholder {
      /* Mozilla Firefox 19+*/
      color: #999999;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10+*/
      color: #999999;
    }
    .input-value:focus {
      border-radius: 45px 0 0 45px !important;
      outline: none !important;
      // outline: 1px solid #10b3ff !important;
      padding-left: 59px;
      border: 1px solid #10b3ff;
    }

    //   .el-input {
    //   background-color: #ccc !important;
    // }

    ::v-deep .input-value .el-input__inner {
      width: calc(100vw - 810px);
      max-width: 1280px;
      height: 90px;
      padding: 0 60px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // color: #999999;
      color: #4d4d4d;
      line-height: 90px;
      background: #ffffff;
      border-radius: 45px 0 0 45px !important;
      border: none;
      box-sizing: border-box;
      &:focus {
        outline: 1px solid #10b3ff !important;
      }
    }

    .btn {
      width: 170px;
      height: 90px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 90px;
      text-align: center;
      background: #10b3ff;
      border-radius: 0px 45px 45px 0px;
      cursor: pointer;
    }
  }

  .search-select {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100%;
    // min-width: 1561px;
    width: calc(100vw - 360px);
    max-width: 1561px;
    margin: 0 auto;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4d4d4d;
  }

  .search-select-title {
    flex-shrink: 0;
  }

  .result-total {
    // width: 1561px;
    width: calc(100vw - 360px);
    max-width: 1561px;
    margin: 40px auto 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4d4d4d;
    line-height: 16px;
  }
  .result-table {
    // width: 1561px;
    width: calc(100vw - 360px);
    max-width: 1561px;
    // height: 562px;
    height: calc(100vh - 510px);
    margin: 0 auto;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    .data {
      display: flex;
      justify-content: center;
      align-items: center;
      .data-item {
        margin-right: 29px;
        font-size: 14px;
        color: #4c4c4c;
        &:last-child {
          margin-right: 0;
        }
        .data-icon {
          margin-right: 4px;
        }
      }
    }
    .pagination {
      float: right;
    }
  }

  .resource-detail-block {
    position: fixed;
    top: 100px;
    left: 0;
    width: 100vw;
    padding: 0 140px;
    height: calc(100vh - 100px);
    background: #f2f5f8;
    box-sizing: border-box;
    z-index: 9;
    .top-line {
      display: flex;
      height: 81px;
      align-items: center;
    }
    .small-button {
      width: 56px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #00aeff;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #00aeff;
      user-select: none;
      cursor: pointer;
    }
    .title {
      font-size: 18px;
      color: #4d4d4d;
      margin-left: 20px;
    }
  }
}
</style>
